import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircleIcon } from 'lucide-react';
const includes = [{
  title: 'El eBook Completo',
  description: '"Gato Zen: Fin a los maullidos nocturnos" (Paso a paso detallado).'
}, {
  title: 'El Método 15-5-10',
  description: 'La técnica de juego que agota el sistema nervioso del gato en minutos.'
}, {
  title: 'Guía de la "Cena Táctica"',
  description: 'Qué y cuándo darle de comer para inducir el sueño postprandial.'
}, {
  title: 'Protocolo de Respuesta Cero',
  description: 'Cómo reaccionar a las 3 AM para extinguir el maullido para siempre.'
}, {
  title: 'Checklist de "Habitación Blindada"',
  description: 'Configuración del ambiente para el silencio total.'
}];
export function WhatYouGet() {
  return <section className="py-10 sm:py-14 relative" data-id="element-373">
      <div className="mx-auto max-w-7xl px-6 lg:px-8" data-id="element-374">
        <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center" data-id="element-375">
          <div className="mb-10 lg:mb-0" data-id="element-376">
            <FadeIn data-id="element-377">
              <h2 className="text-3xl sm:text-4xl font-bold mb-6" data-id="element-378">
                ¿Qué incluye el Kit Gato Zen?
              </h2>
            </FadeIn>

            <div className="space-y-4" data-id="element-379">
              {includes.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-380">
                  <div className="flex gap-4 p-4 rounded-xl bg-navy-light/50 border border-white/5 hover:border-gold/30 transition-colors" data-id="element-381">
                    <CheckCircleIcon className="h-6 w-6 text-gold shrink-0" data-id="element-382" />
                    <div data-id="element-383">
                      <h3 className="font-bold text-slate-100 text-lg" data-id="element-384">
                        {item.title}
                      </h3>
                      <p className="text-slate-400 font-sans mt-1" data-id="element-385">
                        {item.description}
                      </p>
                    </div>
                  </div>
                </FadeIn>)}
            </div>
          </div>

          <FadeIn direction="left" delay={0.3} data-id="element-386">
            <div className="relative mx-auto w-full max-w-md lg:max-w-none" data-id="element-387">
              <div className="absolute -inset-4 z-0 bg-gradient-radial from-gold/20 to-transparent opacity-50 blur-2xl" data-id="element-388" />
              <img src="https://cdn.magicpatterns.com/uploads/3wNJ8cPmdAYXx6vMg6UdiJ/Mockup.png" alt="Kit Gato Zen" className="relative z-10 w-full rounded-2xl shadow-2xl ring-1 ring-white/10" data-id="element-389" />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}